import type { InheritanceStepCriteria, NewProcessAnalysisConfig } from '../Processes/types'

export enum StatusMessageType {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
}

export interface ExportStatsResponse {
  total_transactions: number
  total_events: number
  first_timestamp: string
  last_timestamp: string
  process_identifier_name: string
}

export type ProcessDataExportResponse = Blob

/** Client-only id so rule rows keep stable identity for Save gating (not sent to the API). */
export type StepCriteriaRow = InheritanceStepCriteria & { rowClientId: string }

/** Fields edited by react-hook-form in ProcessForm (basic tab). */
export type ProcessFormFields = Pick<
  NewProcessAnalysisConfig,
  | 'name'
  | 'process_identifier_name'
  | 'process_category'
  | 'process_data_origin'
  | 'initial_visible_variant_amount'
  | 'state_tag_key'
>

